module.exports = __webpack_public_path__ + "static/media/exhibition-services-img20.59facca3.jpg";